import { render, staticRenderFns } from "./SolicitudIndex.vue?vue&type=template&id=3fc73245"
import script from "./SolicitudIndex.vue?vue&type=script&lang=js"
export * from "./SolicitudIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports